module.exports = "<h1 data-bind=\"text: errorStatus\"></h1><h3 data-bind=\"text: errorDisplayMessage\"></h3>";
